<ion-list>
  <ng-container *ngFor="let p of tree$ | async; trackBy: trackByKey">
    <!-- ========================= -->
    <!-- TOP-LEVEL: leaf (no children) -->
    <!-- ========================= -->
    <ion-menu-toggle auto-hide="false" *ngIf="!p.children?.length">
      <ion-item
        *ngIf="p.action === 'logout'; else normalTopLeaf"
        (click)="logout()"
        button
        class="admia-side-menu-item"
        lines="none"
        [class.admia-disabled]="p.disabled">
        <ion-icon [name]="p.icon" slot="start"></ion-icon>
        <ion-label>{{ p.label | translate }}</ion-label>
      </ion-item>

      <!-- normal leafs with router click -->
      <ng-template #normalTopLeaf>
        <ion-item
          [routerLink]="p.route"
          [routerDirection]="'root'"
          button
          class="admia-side-menu-item"
          lines="none"
          [class.admia-disabled]="p.disabled">
          <ion-icon [name]="p.icon" slot="start"></ion-icon>
          <ion-label>{{ p.label | translate }}</ion-label>
        </ion-item>
      </ng-template>
    </ion-menu-toggle>

    <!-- ========================= -->
    <!-- TOP-LEVEL: node with children -->
    <!-- ========================= -->
    <mat-accordion
      *ngIf="p.children?.length"
      class="admia-side-menu-acordion"
      [multi]="false">
      <mat-expansion-panel
        #personsPanel="matExpansionPanel"
        class="admia-side-menu-item"
        [expanded]="expandedRootKey === p.key"
        (opened)="onRootOpened(p.key)">
        <mat-expansion-panel-header>
          <ion-item
            class="admia-side-menu-item-header"
            lines="none"
            (click)="onParentClick(p)"
            [class.admia-link]="!!p.route">
            <ion-icon [name]="p.icon" slot="start"></ion-icon>
            <ion-text>{{ p.label | translate }}</ion-text>

            <ion-badge
              *ngIf="
                p.key === 'persons' &&
                (requestedAbsences ?? 0) > 0 &&
                !personsPanel.expanded
              "
              slot="end">
              {{ requestedAbsences }}
            </ion-badge>
          </ion-item>
        </mat-expansion-panel-header>

        <!-- ========================= -->
        <!-- level 1: children of p -->
        <!-- ========================= -->
        <ng-container *ngFor="let item of p.children; trackBy: trackByKey">
          <!-- level 1: leaf (no item.children) -->
          <ion-menu-toggle auto-hide="false" *ngIf="!item.children?.length">
            <ion-item
              [routerLink]="item.route"
              [routerDirection]="'root'"
              button
              class="admia-sub-menu-item"
              lines="none"
              [class.admia-disabled]="item.disabled">
              <ion-icon [name]="item.icon" slot="start"></ion-icon>
              <ion-label>{{ item.label | translate }}</ion-label>

              <ion-badge
                *ngIf="
                  p.key === 'persons' &&
                  item.key === 'absencePlannerPersons' &&
                  (requestedAbsences ?? 0) > 0 &&
                  personsPanel.expanded
                "
                slot="end">
                {{ requestedAbsences }}
              </ion-badge>
            </ion-item>
          </ion-menu-toggle>

          <!-- level 1: node (has children) -> under accordion level 2 -->
          <mat-accordion
            *ngIf="item.children?.length"
            class="admia-submenu-nested">
            <mat-expansion-panel class="admia-side-menu-item">
              <mat-expansion-panel-header>
                <ion-item
                  class="admia-side-menu-item-header"
                  lines="none"
                  (click)="onChildParentClick(item)"
                  [class.admia-link]="!!item.route">
                  <ion-icon [name]="item.icon" slot="start"></ion-icon>
                  <ion-text>{{ item.label | translate }}</ion-text>
                </ion-item>
              </mat-expansion-panel-header>

              <!-- ========================= -->
              <!-- currently not in use. children of children and we do not yet have those -->
              <!-- ========================= -->
              <ng-container
                *ngFor="let g of item.children; trackBy: trackByKey">
                <ion-menu-toggle auto-hide="false">
                  <ion-item
                    [routerLink]="g.route"
                    [routerDirection]="'root'"
                    button
                    class="admia-sub-menu-item"
                    lines="none"
                    [class.admia-disabled]="g.disabled">
                    <ion-icon [name]="g.icon" slot="start"></ion-icon>
                    <ion-label>{{ g.label | translate }}</ion-label>

                    <!-- not needed rn  -->
                    <ion-badge
                      *ngIf="
                        p.key === 'persons' &&
                        g.key === 'absencePlannerPersons' &&
                        (requestedAbsences ?? 0) > 0 &&
                        personsPanel.expanded
                      "
                      slot="end">
                      {{ requestedAbsences }}
                    </ion-badge>
                  </ion-item>
                </ion-menu-toggle>
              </ng-container>
            </mat-expansion-panel>
          </mat-accordion>
        </ng-container>
      </mat-expansion-panel>
    </mat-accordion>
  </ng-container>
</ion-list>
